import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { type CommonInputProps, useInput } from "react-admin";

import { DEFAULT_DATE_FORMAT } from "@/constants/date";

import { defaultIsoDateFormat } from "./utils/defaultIsoDateFormat";

export const IsoDateInput = ({
  onBlur,
  onChange,
  label,
  format = defaultIsoDateFormat,
  ...rest
}: CommonInputProps) => {
  const { field } = useInput({
    onBlur,
    onChange,
    format,
    ...rest,
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        {...field}
        {...rest}
        format={DEFAULT_DATE_FORMAT}
      />
    </LocalizationProvider>
  );
};
